<template>
    <div class="amazonProductCount-container">
        <el-tabs v-model="activeName" @tab-click="search">
            <el-tab-pane label="汇总" name="total"></el-tab-pane>
            <el-tab-pane label="明细" name="detail"></el-tab-pane>
        </el-tabs>
        <div class="select-box">
            <div class="select-item">
                <div class="label">时间</div>
                <el-date-picker v-model="startDate" type="date" style="width:100%"
                    value-format="yyyy-MM-dd" />
            </div>
            <div class="select-item">
                <div class="label">至</div>
                <el-date-picker v-model="endDate" type="date" style="width:100%"
                    value-format="yyyy-MM-dd" />
            </div>
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="exportData" type="primary" v-loading="exportLoading">导出</el-button>
        </div>
        <!-- 汇总表格 -->
        <el-table :data="tableData" v-if="activeName === 'total'" border stripe height="700">
            <el-table-column prop="name" label="姓名" align="center" />
            <el-table-column prop="date" label="日期" align="center" />
            <el-table-column prop="count" label="有效产品数量" align="center" />
        </el-table>

        <!-- 明细表格 -->
        <el-table :data="tableData" v-if="activeName === 'detail'" border stripe height="650">
            <el-table-column prop="shopName" label="店铺名称" align="center" />
            <el-table-column prop="countryName" label="国家名称" align="center" />
            <el-table-column prop="itemName" label="产品名称" show-overflow-tooltip />
            <el-table-column prop="sellerSku" label="卖家SKU" align="center" />
            <el-table-column prop="listingId" label="Listing ID" align="center" />
            <el-table-column prop="openDate" label="上架日期(北京时间)" align="center" />
            <el-table-column prop="listingStatus" label="Listing状态" align="center" />
            <el-table-column prop="openDateRaw" label="原始上架日期" align="center" />
        </el-table>

        <div class="pagination-box" v-if="activeName === 'detail'">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
                :page-size="pageSize" :current-page="pageNum" :page-sizes="[10, 20, 50, 100]"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
    </div>
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from "@/api/api/api";
import axios from 'axios';
export default {
    name: 'amazonProductCount',
    components: {},
    props: {},
    data() {
        return {
            shopIds: [],
            startDate: "",
            endDate: "",
            activeName: 'total',
            tableData: [],
            total: 0,
            pageNum: 1,
            pageSize: 20,
            exportLoading: false,
        };
    },
    created() {
        const sellerInfoText = localStorage.getItem('sellerInfo');
        if(sellerInfoText){
            const sellerInfo = JSON.parse(sellerInfoText);
            this.shopIds = sellerInfo.shopIds;
        }
        if(!this.shopIds.length){
            this.$message.error("请绑定店铺！");
            return
        }
        const yesterday = this.getYesterdayDate();
        this.startDate = yesterday;
        this.endDate = yesterday;
        this.getSummaryData();//获取汇总数据
    },
    mounted() {},
    watch: {},
    computed: {},
    methods: {
        // 每页条数变化
        handleSizeChange(size) {
            this.pageSize = size
            this.pageNum = 1
            this.search()
        },


        // 页码变化
        handleCurrentChange(page) {
            this.pageNum = page
            this.search()
        },

        getYesterdayDate() {
            const date = new Date();
            date.setDate(date.getDate() - 1);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        search(){
            this.tableData = [];
            if(this.activeName === 'total'){
                this.getSummaryData();//获取汇总数据
            }else{
                this.getDetailData();//获取明细数据
            }
        },
        getSummaryData(){
            const params = {
                shopIds: this.shopIds,
                startDate: this.startDate,
                endDate: this.endDate
            }
            ajaxPost(Baseurl + "amazonProductCountController/getSummaryData", params).then(res => {
                if(res.data.code === 200){
                    this.tableData = res.data.data;
                }
            })
        },
        getDetailData() {
            const params = {
                shopIds: this.shopIds,
                startDate: this.startDate,
                endDate: this.endDate,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            }
            ajaxPost(Baseurl + "amazonProductCountController/getDetailData", params).then(res => {
                if(res.data.code === 200){
                    const d = res.data.data;
                    this.total = d.total;
                    this.tableData = d.list;
                }
            })
        },
        exportData(){
            const params = {
                startDate: this.startDate,
                endDate: this.endDate,
                shopIds: this.shopIds
            }
            let url = '';
            if (this.activeName === 'total') {
                url = Baseurl + 'amazonProductCountController/export/summary';
            } else {
                url = Baseurl + 'amazonProductCountController/export/detail';
            }
            this.exportByPost(url, params);
        },
        exportByPost(url, params) {
            this.exportLoading = true;
            axios({
                url: url,
                method: 'post',
                data: params,
                responseType: 'blob',
                timeout: 600000
            }).then(res => {

                let blob = new Blob([res.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = "亚马逊产品上传明细.xlsx";
                link.click();
                window.URL.revokeObjectURL(link.href);
            }).finally(() => {
                this.exportLoading = false;
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.select-box{
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
    .select-item{
        display: flex;
        align-items: center;
        margin-right: 20px;
        .label{
            width: 40px;
        }
    }
}
.pagination-box {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;
}
</style>